import { render, staticRenderFns } from "./doctorSetup.vue?vue&type=template&id=8d9754a8&"
import script from "./doctorSetup.vue?vue&type=script&lang=js&"
export * from "./doctorSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports